import { Card } from 'antd';
import React from 'react';
import UpdateLoginPassword from './UpdateLoginPassword';
import UpdateDealPassword from "./UpdateDealPassword";
import ApiKey from "./ApiKey";
import BindSecretCode from "./BindSecretCode";
import userAuth from '../../auth/UserAuth';
import ModelConstants from '../../constants/ModelConstants';

class CustomerSecurity extends React.Component {

  handleTabChange = key => {
    this.props.history.push('/security/' + key)
  };

  render() {
    let tabs = [
      {
        key: 'login_psw',
        tab: '修改登录密码'
      },
      {
        key: 'deal_psw',
        tab: '修改交易密码'
      },
    ];

    if(userAuth.user().type === ModelConstants.USER_TYPE.MAIN) {
      tabs.push({
        key: 'api_key',
        tab: '接口密钥'
      });
    }

    const contentList = {
      login_psw: <UpdateLoginPassword />,
      deal_psw: <UpdateDealPassword />,
      api_key: <ApiKey />,
      settings: '待开发',
      white_ip: '待开发'
    };

    return (
      <Card activeTabKey={this.props.match.params.tab} tabList={tabs} className='narrow' onTabChange={this.handleTabChange}>
        {
          contentList[this.props.match.params.tab.replace('-', '_')]
        }
      </Card>
    );
  }
}

export default CustomerSecurity;
